import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import TableRow from './TableRow';
import withSortedPageRows from '../hoc/withSortedPageRows';

var Body = function (_Component) {
  _inherits(Body, _Component);

  function Body() {
    _classCallCheck(this, Body);

    return _possibleConstructorReturn(this, (Body.__proto__ || _Object$getPrototypeOf(Body)).apply(this, arguments));
  }

  _createClass(Body, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pageRows = _props.pageRows,
          head = _props.head,
          isFixedSize = _props.isFixedSize;


      return React.createElement(
        'tbody',
        null,
        pageRows.map(function (row, rowIndex) {
          return React.createElement(TableRow, {
            head: head,
            isFixedSize: isFixedSize,
            key: rowIndex // eslint-disable-line react/no-array-index-key
            , row: row
          });
        })
      );
    }
  }]);

  return Body;
}(Component);

export default withSortedPageRows(Body);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/components/Body.js
// module id = 854
// module chunks = 0